export const CURRENT_USER_QUERY_KEY = ['current_user'] as const;
